import Swiper, { Keyboard, Navigation, Pagination } from 'swiper';
import { merge } from 'lodash';
import 'swiper/css';
import 'swiper/css/pagination';

class Slider {
  el;
  id;
  type;
  instance = null;
  options = {
    modules: [ Keyboard, Navigation, Pagination ],
    navigation: {
      prevEl: '[data-slider-prev]',
      nextEl: '[data-slider-next]',
      disabledClass: 'slider__button--disabled',
      hiddenClass: 'slider__button--hidden',
      lockClass: 'slider__button--lock',
      navigationDisabledClass: 'slider-navigation-disabled',
    },
    pagination: {
      el: '[data-slider-pagination]',
      type: 'bullets',
      clickable: true,
    },
    threshold: 5,
  };

  constructor(el, options) {
    this.el = el;
    this.id = this.el.dataset.id;
    this.type = this.el.dataset.type;
    this.options = merge(this.options, options);
    this.instantiate(this.el, this.options);
    this.addEventListeners();
  }

  instantiate(el, options) {
    this.instance = new Swiper(el, {
      ...options,
    });
    // Dirty fix to prevent navigation click from triggering twice
    if (this.type === 'gallery-slider') {
      this.instance.navigation.destroy();
      this.instance.navigation.init();
    }
  }

  addEventListeners() {
    window.emitter.on('slider:slide-to', ({ id, index, speed }) => {
      if (this.id && Number(this.id) === id) {
        this.instance.slideTo(index, speed, false);
      }
    });
    if (this.type === 'gallery-slider') {
      this.instance.on('activeIndexChange', (swiper) => {
        window.emitter.emit('gallery:set-slide-index', ({ index: swiper.activeIndex }));
        window.emitter.emit('gallery:focus-nav');
      });
    }
  }
}

export default Slider;
